/**
 * Tuning for the hand-drawn scribble; stroke geometry lives in `./geometry`.
 * Distances are px relative to the bar's box. The editor's inline extension
 * lozenge sits ~2.2px above the box top and ~0.7px above its bottom for 16px
 * body text, which is what the vertical insets are measured against.
 */
export const PARAMS = {
	duration: 800, // ms, total draw time across all strokes
	delay: 400, // ms before the first stroke starts
	cascadeOffset: 10, // ms between adjacent bars
	strokeWidth: 0.4, // fraction of a 20px line, min 6px
	strokeCount: 5, // per ~20px of line height
	wiggle: 1.5, // control-point Y variance
	jitter: 1.5, // Y offset of the inner strokes
	edgeJitter: 0.5, // Y offset of the top and bottom strokes, kept small so the edges stay near their bounds
	drift: 0.08, // control-point X variance, fraction of stroke length
	capJitter: 1, // how far a stroke end may stop short of the side margin
	insetX: 0, // ink to the box's side edges
	insetTop: -2.65, // ink to the box's top edge; negative is above the box (0.5px inside the outline)
	insetBottom: 0.2, // ink to the box's bottom edge (0.5px inside the outline)
	iconSize: 12, // GuardIcon xxsmall (16px) scaled to 0.75
	iconOffset: -1.425, // icon center relative to the box center, on the lozenge center; matches the icon's translateY
} as const;
